import React from 'react'
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';

const Slider = () => {
    const AutoplaySlider = withAutoplay(AwesomeSlider);
    return (
        <AutoplaySlider
            play={true}
            cancelOnInteraction={false}
            interval={5000}
        >
           
            <div data-src="https://cdn.pixabay.com/photo/2017/09/16/01/41/poor-2754335_960_720.jpg" />
            <div data-src=" https://cdn.pixabay.com/photo/2017/06/07/10/47/elephant-2380009_960_720.jpg" />
            <div data-src="https://cdn.pixabay.com/photo/2015/08/05/13/55/children-876543_960_720.jpg" />
            <div data-src="https://cdn.pixabay.com/photo/2015/07/27/20/16/book-863418_960_720.jpg" />
            <div data-src="https://cdn.pixabay.com/photo/2020/11/10/21/00/boy-5731001_960_720.jpg" />
            <div data-src="https://cdn.pixabay.com/photo/2021/08/01/17/31/path-6514885_960_720.jpg" />
          
        </AutoplaySlider>
    )
    
}

export default Slider
